export default "__VITE_ASSET__dc9da26d__"